import React, { useContext } from 'react'
import { ChangePresentContext, OpsPlanContext } from '../../../SingleEvent'
import { Grid, TextField } from '@mui/material'

const Location = () => {
  const { opsPlan, setOpsPlan } = useContext(OpsPlanContext)
  const { changesPresent, setChangesPresent } = useContext(ChangePresentContext)

  return (
    <Grid item xs={12} lg={6}>
      <TextField
        label="Address/Location"
        fullWidth
        multiline
        value={opsPlan?.location}
        InputLabelProps={{
          shrink: opsPlan?.location ? true : false,
        }}
        onChange={(e) => {
          setOpsPlan((prev) => ({
            ...prev,
            location: e.target.value,
          }))
          !changesPresent && setChangesPresent(true)
        }}
        autoComplete="off"
        name="opsplan-location"
      />
    </Grid>
  )
}

export default React.memo(Location)
